import { inject } from '@angular/core';
import { ADDRESS_SEARCHER_OPTIONS, AddressSearcher, IAddressSearcherData, IAddressSearcherOptions } from '@df/ui/form/address-searcher';

export abstract class AddressSearcherService {
    protected readonly options = inject(ADDRESS_SEARCHER_OPTIONS);

    abstract create(addressSearcherData: IAddressSearcherData): AddressSearcher;
}
